import React from "react";
import InvoiceInfo from "features/invoices/components/InvoiceInfo";
import RoundButton from "features/shared/components/buttons/RoundButton";
import PriceFormatter from "features/shared/components/formatters/PriceFormatter";
import styles from "features/payments/components/paymentusagerow.module.scss";
import PaymentUsageDTO from "features/payments/dtos/PaymentUsageDTO";
import { getDepositDetailRoute } from "features/shared/helpers/routeHelper";

interface IProps {
  paymentUsage: PaymentUsageDTO;
  depositId: string;
  showInvoiceTimePeriod?: boolean;
}

const DepositUsageRow: React.FC<IProps> = ({ paymentUsage, depositId, showInvoiceTimePeriod }) => {
  const { amount, invoiceUsage, paymentDocument } = paymentUsage;

  const doc = invoiceUsage ?? paymentDocument;

  return (
    <div className={styles.paymentDetailRow}>
      <div className="row align-items-center no-gutters">
        <div className="col">
          <div className="row no-gutters align-items-center">
            <div className={`d-none d-sm-block offset-sm-2 col-sm-2 align-self-stretch ${styles.paymentTreeItem}`} />

            <div className="col-12 col-sm-3">
              <div className="d-flex flex-column">
                <div className="text-truncate">
                  <PriceFormatter
                    amount={amount ?? 0}
                    currency={doc?.currency!}
                  />
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-5">
              <InvoiceInfo
                invoiceType={doc?.invoiceType!}
                invoiceSubType={doc?.invoiceSubType!}
                commodityDetails={doc?.commodityDetail ?? []}
                entityLinks={doc?.entityLinks ?? []}
                timePeriodFrom={doc?.timePeriodFrom}
                timePeriodTo={doc?.timePeriodTo}
                mobileBehaviour
                showTimePeriod={showInvoiceTimePeriod}
              />
            </div>
          </div>
        </div>

        <div className="col-auto">
          <RoundButton asLink to={getDepositDetailRoute(depositId)} />
        </div>
      </div>
    </div>
  );
};

export default DepositUsageRow;
